// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__jXYPx"};